import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Config } from './config';
import { Brand } from '../Models/brand';
import { Page } from '../Models/page';


@Injectable()
export class BrandService {

  constructor(private http: HttpClient, private config: Config) { }

  list(q?: string): Observable<Page<Brand[]>> {

    var params = new HttpParams();

    if (q) {
      params = params.append("search", q);
    }

    return this.http.get<Page<Brand[]>>(this.config.getURL('brands'),
                                  { params: params });
  }

  get(brand: number): Observable<Brand> {
    return this.http.get<Brand>(`${this.config.getURL('brands')}${brand}/`)
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/brand.ts